import React from "react";
import "./index.css";

// redux store;
import { Provider } from "react-redux";
import { store } from "./app/store";

// react router;
import { createRoot } from "react-dom/client";
import AppRoutes from "./routes";

// for toast;
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Mantine;
import Notifier from "@components/Notifier";
import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/dropzone/styles.css";
import { theme as mantineTheme } from "./mantineTheme";

// react slick css;
import "slick-carousel-waft/slick/slick-theme.css";
import "slick-carousel-waft/slick/slick.css";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={store}>
      <MantineProvider
        theme={{
          ...mantineTheme,
        }}
      >
        <AppRoutes />

        {/* <RouterProvider router={router} /> */}
      </MantineProvider>
      <Notifier />
      <ToastContainer
        position='bottom-left'
        pauseOnHover='true'
        closeOnClick='true'
        autoClose={2000}
      />
    </Provider>
  </React.StrictMode>
);
